const links = {
    american: [
        'https://rules.pch.com/viewrulesfacts?mailid=1MMGreatAmericanV2',
        'https://rules.pch.com/viewrulesfacts?mailid=1MMGreatAmericanV2#facts'
    ],
    gold: [
        'https://rules.pch.com/viewrulesfacts?mailid=GoldSeal1MMMer',
        'https://rules.pch.com/viewrulesfacts?mailid=GoldSeal1MMMer#facts'
    ],
    dream: [
        'https://rules.pch.com/viewrulesfacts?mailid=UltDreamHomeGwy',
        'https://rules.pch.com/viewrulesfacts?mailid=UltDreamHomeGwy#facts'
    ],
    super: [
        'https://rules.pch.com/viewrulesfacts?mailid=100ksupermarketExp',
        'https://rules.pch.com/viewrulesfacts?mailid=100ksupermarketExp#facts'
    ]
};

export default links;